// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".EYzOp {\n  display: block;\n  position: fixed;\n  z-index: 1298;\n  padding: 8px 0;\n  color: white;\n  height: 100%;\n  width: 64px;\n  left: 0;\n  top: 64px;\n  border-radius: 0 !important;\n  -webkit-box-shadow: rgba(0, 0, 0, 0.2) 2px 0 20px !important;\n          box-shadow: rgba(0, 0, 0, 0.2) 2px 0 20px !important;\n}\n\n.EYzOp:hover {\n  overflow-y: auto;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sideNav": "EYzOp"
};
export default ___CSS_LOADER_EXPORT___;
